import { ErrorBoundary } from '@monorepo/shared/componentsV2/ErrorBoundary';
import { RoutesWith404 } from '@monorepo/shared/componentsV2/RoutesWith404';
import { useIsSuperAdmin } from '@monorepo/shared/hooks/permissions/useIsSuperAdmin';
import { EditWorkflowPage } from '@monorepo/workflowDataSetup/src/components/EditWorkflowPage/EditWorkflowPage';
import { EditWorkflowStepsPage } from '@monorepo/workflowDataSetup/src/components/EditWorkflowStepsPage';
import { WorkflowAnalyticsSyncPage } from '@monorepo/workflowDataSetup/src/components/WorkflowAnalyticsSyncPage';
import { useFeatureFlags } from 'mapistry-shared/api';
import React from 'react';
import { Navigate, Route } from 'react-router-dom';
import { EditWorkflowOutputPreviewPage } from './components/EditWorkflowOutputPreviewPage/EditWorkflowOutputPreviewPage';
import {
  RouteEditMode,
  WizardStep,
  WizardStepUrlPart,
} from './components/types';
import { WorkflowDetailsPage } from './components/WorkflowDetailsPage/WorkflowDetailsPage';
import { WorkflowListPage } from './components/WorkflowListPage';

export function WorkflowDataSetupRouter() {
  const { isData2Enabled } = useFeatureFlags();
  const isSuperAdmin = useIsSuperAdmin();

  return isData2Enabled ? (
    <RoutesWith404>
      <Route
        index
        element={
          <ErrorBoundary>
            <WorkflowListPage />
          </ErrorBoundary>
        }
      />
      <Route path={RouteEditMode.NEW}>
        <Route
          index
          element={
            <ErrorBoundary>
              <EditWorkflowPage />
            </ErrorBoundary>
          }
        />
      </Route>
      <Route path=":workflowId">
        <Route
          index
          element={
            <ErrorBoundary>
              <WorkflowDetailsPage />
            </ErrorBoundary>
          }
        />
        <Route path=":mode">
          <Route
            index
            element={
              <Navigate replace to={WizardStepUrlPart[WizardStep.DETAILS]} />
            }
          />
          <Route path={WizardStepUrlPart[WizardStep.DETAILS]}>
            <Route
              index
              element={
                <ErrorBoundary>
                  <EditWorkflowPage />
                </ErrorBoundary>
              }
            />
          </Route>
          <Route
            path={WizardStepUrlPart[WizardStep.STEPS]}
            element={
              <ErrorBoundary>
                <EditWorkflowStepsPage />
              </ErrorBoundary>
            }
          />
          <Route
            path={WizardStepUrlPart[WizardStep.PREVIEW]}
            element={
              <ErrorBoundary>
                <EditWorkflowOutputPreviewPage />
              </ErrorBoundary>
            }
          />
          {isSuperAdmin && (
            <Route
              path={WizardStepUrlPart[WizardStep.ANALYTICS_SYNC]}
              element={
                <ErrorBoundary>
                  <WorkflowAnalyticsSyncPage />
                </ErrorBoundary>
              }
            />
          )}
        </Route>
      </Route>
    </RoutesWith404>
  ) : null;
}
